import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/HomeView.vue";
import ClientsList from "../views/clients/ClientsList.vue";
import MeasurementsForm from "../components/forms/MeasurementsForm.vue";
import PaymentsView from "../views/PaymentsView.vue";
import ClientView from "../views/clients/ClientView.vue";
import ModelView from "../views/models/ModelView.vue";
import ClientCreate from "@/views/clients/ClientCreate.vue";
import ModelCreate from "@/views/models/ModelCreate.vue";
import MeasurementsCreate from "@/views/measurements/MeasurementsCreate.vue";
import TissuCreate from "@/views/tissus/TissuCreate.vue";
import TissuView from "@/views/tissus/TissuView.vue";
import Register from "@/views/auth/Register.vue";
import Login from "@/views/auth/Login.vue";
import AppLayout from "@/layouts/AppLayout.vue";
import Me from "@/views/auth/Me.vue";

const routes = [
  // Auth
  { path: "/login", name: "login", component: Login },
  { path: "/register", name: "register", component: Register },
  // Dashboard

  // App
  {
    path: "/",
    name: "app",
    component: AppLayout,
    redirect: { name: "home" },
    children: [
      { path: "/#", name: "home", component: Home },
      { path: "/auth/me", name: "auth-user", component: Me },
      { path: "/clients", name: "clients", component: ClientsList },
      {
        path: "/clients/create",
        name: "clients.create",
        component: ClientCreate,
      },
      {
        path: "/clients/:id",
        name: "clients.view",
        component: ClientView,
        props: true,
      },
      {
        path: "/clients/:id/edit",
        name: "clients.edit",
        component: ClientCreate,
        props: true,
      },
      {
        path: "/clients/:client_id/models/create",
        name: "models.create",
        component: ModelCreate,
        props: true,
      },
      {
        path: "/clients/:client_id/models/edit/:id",
        name: "models.edit",
        component: ModelCreate,
        props: true,
      },
      {
        path: "/models/:id",
        name: "models.view",
        component: ModelView,
        props: true,
      },
      {
        path: "/measurements",
        name: "measurements",
        component: MeasurementsForm,
      },
      {
        path: "/clients/:client_id/measurements/create",
        name: "measurements.create",
        component: MeasurementsCreate,
        props: true,
      },
      {
        path: "/clients/:client_id/measurements/edit/:id",
        name: "measurements.edit",
        component: MeasurementsCreate,
        props: true,
      },
      {
        path: "/models/:model_id/tissus/create",
        name: "tissus.create",
        component: TissuCreate,
        props: true,
      },
      {
        path: "/models/:model_id/tissus/edit/:id",
        name: "tissus.edit",
        component: TissuCreate,
        props: true,
      },
      {
        path: "/tissus/:id",
        name: "tissus.view",
        component: TissuView,
        props: true,
      },
      { path: "/payments", name: "payments", component: PaymentsView },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
